import { getImageFullUrl, isFullUrl } from "../app/Common/Enum/helper"

class MerchantMenu {
    getImageUrl = () => {
        let imageUrl = (window.appSetting && window.appSetting.resource_use_storage_url && this.storage_url) || this.image_path
        if (imageUrl) {
            imageUrl = isFullUrl(imageUrl) ? imageUrl : getImageFullUrl(imageUrl)
        }
        return imageUrl
    }
}
export default MerchantMenu










